export default __webpack_public_path__ + "static/media/firefox.ec6cc014.png";